import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '..';
import { StateStatus } from '../../utils/common';
import * as AdminDashboardService from '../../../services/api/admin_dashboard';
import { useSelector } from 'react-redux';
import { IState } from './reducer';

interface AdminDashboardDataOutput {
  status: StateStatus;
  data: AdminDashboardService.IAdminDashboardDataOutput | null;
}

export const useGetAdminDashboardData = (): AdminDashboardDataOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.ADMIN_DASHBOARD_REDUCER].adminDashboardData
  );
  return data;
};

interface TraderDashboardDataOutput {
  status: StateStatus;
  data: AdminDashboardService.ITraderDashboardDataOutput | null;
}

export const useGetTraderDashboardData = (): TraderDashboardDataOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.ADMIN_DASHBOARD_REDUCER].traderDashboardData
  );
  return data;
};
